import React, { useEffect, useState } from "react";
import { IoIosMenu } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import ProfileIcon from "./ProfileIcon";

const Header = () => {
	const [isOpen, setIsOpen] = useState(false);
	const navigate = useNavigate();

	useEffect(() => {
		if (isOpen) {
			document.body.style.overflow = "hidden";
		} else {
			document.body.style.overflow = "auto";
		}

		return () => {
			document.body.style.overflow = "auto";
		};
	}, [isOpen]);

	const pageNavigate = (id) => {
		navigate(`/${id}`);
	};

	return (
		<div className="w-full">
			{/* Desktop Navbar */}
			<div className="sticky top-0 bg-white z-50 hidden lg:flex justify-between items-center pt-6 px-10 text-sm font-medium h-fit">
				{/* Left side */}
				<div className="flex justify-start items-center gap-8">
					<button
						className="flex items-center gap-2"
						onClick={() => pageNavigate("Enroll")}
					>
						<span>Courses</span>
					</button>
					<button onClick={() => pageNavigate("ClassRoom")}>
						Live ClassRoom
					</button>
					<button onClick={() => pageNavigate("contact")}>
						Contact
					</button>
				</div>

				{/* Center Logo */}
				<div
					className="absolute left-1/2 transform -translate-x-1/2 flex items-center gap-1"
					onClick={() => pageNavigate("")}
				>
					<span className="font-bold text-lg">E-learning</span>
					<span className="text-gray-500">.io</span>
				</div>

				{/* Right side */}
				<div className="flex justify-end items-center gap-8 relative">
					<button onClick={() => pageNavigate("help")}>Help</button>
					<button onClick={() => pageNavigate("blog")}>Blog</button>
					<ProfileIcon />
				</div>
			</div>

			{/* Mobile Navbar */}
			<div className="sticky top-0 bg-white z-50 flex justify-between items-center py-4 px-6 lg:hidden shadow-md">
				{/* Hamburger Icon */}
				<div className="flex items-center">
					<IoIosMenu
						className="text-3xl cursor-pointer text-gray-700"
						onClick={() => setIsOpen(!isOpen)}
					/>
				</div>

				{/* Logo */}
				<div className="flex items-center gap-1">
					<span className="font-bold text-lg text-blue-600">
						E-learning
					</span>
					<span className="text-gray-500">.io</span>
				</div>

				{/* Mobile Menu */}
				{isOpen && (
					<div className="fixed inset-0 bg-gray-800 bg-opacity-50 z-40 flex justify-end">
						{/* Menu Content */}
						<motion.div
							initial={{ x: "100%" }}
							animate={{ x: 0 }}
							exit={{ x: "100%" }}
							className="w-2/3 max-w-sm bg-white h-full shadow-lg p-6 flex flex-col space-y-4"
						>
							{/* Close Button */}
							<button
								className="self-end text-gray-500 text-xl focus:outline-none"
								onClick={() => setIsOpen(false)}
							>
								✕
							</button>

							{/* Menu Links */}
							<button
								onClick={() => pageNavigate("about")}
								className="text-lg font-medium text-gray-800 hover:text-blue-600"
							>
								About
							</button>
							<button
								onClick={() => pageNavigate("pages")}
								className="text-lg font-medium text-gray-800 hover:text-blue-600"
							>
								Pages
							</button>
							<button
								onClick={() => pageNavigate("contact")}
								className="text-lg font-medium text-gray-800 hover:text-blue-600"
							>
								Contact
							</button>
							<button
								onClick={() => pageNavigate("help")}
								className="text-lg font-medium text-gray-800 hover:text-blue-600"
							>
								Help
							</button>
							<button
								onClick={() => pageNavigate("blog")}
								className="text-lg font-medium text-gray-800 hover:text-blue-600"
							>
								Blog
							</button>
						</motion.div>
					</div>
				)}
			</div>
		</div>
	);
};

export default Header;
